//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// =========================================
// 父组件需要提供的方法 名称
// =========================================

/**
 * 获取滑块图片方法
 */
const GET_IMG_FUN = 'getImg'
/**
 * 校验滑块图片方法
 */
const VALID_IMG_FUN = 'validImg'
/**
 * 滑块窗口关闭事件监听
 */
const CLOST_EVENT_FUN = 'close'
export default {
  props: {
    // 是否开启日志， 默认true
    log: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      blcokLeft: 0,
      bgImg: '',
      sliderImg: '',
      startX: 0,
      uuid: '',
      startMove: false,
      moveBtnPosition: 11.79625,
      moveX: 0
    }
  },
  mounted() {
    this.getImg()
  },
  methods: {

    /**
     * 按钮关闭事件
     */
    close() {
      this.$parent.closeSlide()
    },
    /**
     * 打印日志
     */
    printLog(msg, ...optionalParams) {
      if (this.log) {
        if (optionalParams && optionalParams.length > 0) {
          console.info(
            `滑块验证码[${msg}]`,
            optionalParams.length === 1 ? optionalParams[0] : optionalParams
          )
        } else {
          console.info(`滑块验证码[${msg}]`)
        }
      }
    },
    /**
     * 获取滑块图片
     */
    getImg() {
      this.loading = true
      var params = {}
      this.$get('/sys/img/gen',params,function(res){
        if (res.code == 200) {
          this.bgImg = res.data.backgroundImage
          this.sliderImg = res.data.sliderImage
          this.uuid = res.data.uuid
        }
      })
    },
    /**
     * 校验图片
     */
    validImg() {
      var params = {
        imgCode: this.moveX * 2,
        uuid: this.uuid
      }
      this.$get('/sys/img/check',params,function(res){
        if (res.code == 200) {
          if (res.data == true) {
            this.$parent.loginFunc(this.moveX * 2, this.uuid)
          }
        } else {
          this.reset()
        }
      })
    },
    /**
     * 重新生成图片
     */
    reset() {
      this.getImg()
      this.moveX = 0
      this.movePercent = 0
      this.startX = 0
      this.blcokLeft = 0
    },
    start(e) {
      // this.$refs.move-btn.style =
      this.moveBtnPosition = 31.0092
      this.startX = e.pageX
      this.startMove = true
      window.addEventListener('mousemove', this.move)
      window.addEventListener('mouseup', this.up)
    },
    move(e) {
      if (!this.startMove) return
      const moveX = e.pageX - this.startX
      const movePercent = moveX / 260
      if (moveX <= 0) {
        this.blcokLeft = 0
        this.moveX = 0
        this.movePercent = 0
      } else if (moveX >= 0 && moveX <= 244) {
        this.blcokLeft = moveX
        this.moveX = moveX
        this.movePercent = movePercent
      } else if (moveX >= 244) {
        this.blcokLeft = 244
        this.moveX = 244
        this.movePercent = movePercent
      }
    },
    up(e) {
      window.removeEventListener('mousemove', this.move)
      window.removeEventListener('mouseup', this.up)
      if (!this.startMove) return
      this.startMove = false
      this.moveBtnPosition = 11.79625
      // console.log(this.movePercent)
      this.validImg()
    }
  }
}
